import { render } from "./MonitorStudentsDataTable.vue?vue&type=template&id=d647d7b2&scoped=true"
import script from "./MonitorStudentsDataTable.vue?vue&type=script&lang=js"
export * from "./MonitorStudentsDataTable.vue?vue&type=script&lang=js"

import "./MonitorStudentsDataTable.vue?vue&type=style&index=0&id=d647d7b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d647d7b2"]])

export default __exports__